import React from 'react';
export function PainPoints() {
  return <section className="py-20 bg-[#FFFBF4]" data-id="element-244">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E3A5F] mb-6" data-id="element-247">
            Sabemos que no es fácil lograr que un niño comprenda lo que lee.
          </h2>
          <div className="bg-white p-8 rounded-2xl shadow-md border border-amber-100 text-left max-w-3xl mx-auto" data-id="element-248">
            <p className="text-lg text-slate-700 mb-4 font-medium" data-id="element-249">
              Leer no es el problema… interpretar sí.
            </p>
            <p className="text-lg text-slate-700 mb-4" data-id="element-250">
              Tus alumnos pueden leer en voz alta, pueden decodificar palabras,
              pueden repetir oraciones.
            </p>
            <p className="text-lg text-slate-700 mb-4" data-id="element-251">
              Pero cuando les preguntás qué entendieron… se quedan en blanco. No
              logran conectar ideas, no pueden responder preguntas
              inferenciales, y vos sentís que por más que lo intentás, algo no
              termina de funcionar.
            </p>
            <p className="text-lg text-slate-700 font-medium italic text-[#1E3A5F]" data-id="element-252">
              No es culpa tuya. Es que falta un sistema claro y estructurado
              para trabajar la comprensión paso a paso.
            </p>
          </div>
        </div>

        <div className="mb-16" data-id="element-253">
          <p className="text-xl text-center text-slate-700 font-medium mb-10" data-id="element-254">
            Por eso este material fue creado para trabajar la comprensión
            <br data-id="element-255" />
            <span className="font-bold text-[#1E3A5F]" data-id="element-256">
              de forma simple, clara y estructurada.
            </span>
          </p>
          <p className="text-lg text-center text-slate-600 mb-12" data-id="element-257">
            Y además de mejorar los resultados de tus alumnos, estas actividades
            te ayudan a vos:
          </p>

          <div className="space-y-8" data-id="element-258">
            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-259">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-260">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-261">
                  1
                </span>
                Más tiempo libre
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-262">
                No más domingos buscando material ni noches armando actividades
                de último momento.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-263">
                Todo está listo para imprimir y usar. Recuperás tus tardes, tus
                fines de semana y tu tranquilidad.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-264">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-265">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-266">
                  2
                </span>
                Menos estrés
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-267">
                Sabés exactamente qué dar cada semana. No improvisás, no buscás
                a último momento, no dependés de nadie.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-268">
                Tenés un plan completo que te sostiene todo el año.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#F59E0B]" data-id="element-269">
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 flex items-center" data-id="element-270">
                <span className="bg-[#F59E0B] text-white w-10 h-10 rounded-full flex items-center justify-center mr-4 text-xl" data-id="element-271">
                  3
                </span>
                Mejores resultados
              </h3>
              <p className="text-slate-700 text-lg mb-2" data-id="element-272">
                Tus alumnos no solo leen: comprenden, interpretan y responden
                con seguridad.
              </p>
              <p className="text-slate-700 text-lg font-medium" data-id="element-273">
                Y vos podés demostrarlo con evidencia concreta ante padres y
                directivos.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center bg-[#1E3A5F] text-white p-10 rounded-3xl shadow-xl" data-id="element-274">
          <p className="text-2xl md:text-3xl font-bold leading-relaxed" data-id="element-275">
            No necesitás más esfuerzo.
            <br data-id="element-276" />
            <span className="text-[#FCD34D]" data-id="element-277">
              Necesitás el sistema correcto.
            </span>
          </p>
        </div>
      </div>
    </section>;
}